import { StringKey } from '../../../lang/index';
import { getTranslation } from '../../../utils/get-translation.util';

const KILOBYTE = 1024;
const MEGABYTE = 1024 * 1024;

const NO_SIZE = '-';

// A size as a number and its unit apart, for the cards to set the unit smaller.
export type SpaceSize = { unit?: StringKey; value: string };

// Bytes below a kilobyte, so a small file is never "0 KB"; whole kilobytes; one decimal of a
// megabyte. No unit where there is no size.
export const spaceSizeOf = (bytes: null | number): SpaceSize => {
  if (!bytes) {
    return { value: NO_SIZE };
  }

  if (bytes < KILOBYTE) {
    return { unit: 'SIZE_B', value: String(bytes) };
  }

  if (bytes < MEGABYTE) {
    return { unit: 'SIZE_KB', value: String(Math.round(bytes / KILOBYTE)) };
  }

  const megabytes = Math.round((bytes / MEGABYTE) * 10) / 10;

  return {
    unit: 'SIZE_MB',
    value: Number.isInteger(megabytes) ? String(megabytes) : megabytes.toFixed(1),
  };
};

// A size as the browser table shows it, in one piece.
export const formatSpaceSize = (bytes: null | number): string => {
  const { unit, value } = spaceSizeOf(bytes);

  return unit ? `${value} ${getTranslation(unit)}` : value;
};
